import Head from "next/head";
import { make as TeamBuilderPage } from "../../src/team-planner-core/TeamPlannerPage.bs";
import { lastPatch } from "common/src/Config.ts";

export default function TeamBuilder({ locale }) {
  return (
    <>
      <Head>
        <title>TFT Team Comp Builder - Set 18</title>
      </Head>
      <TeamBuilderPage locale={locale} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      locale,
    },
  };
}
